export default {"src":"/_next/static/media/GOOG.c37d97d5.svg","height":18,"width":18};